import { Injectable } from '@angular/core';

import { PhoneNumber } from '../../models/phone-number';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class PhoneNumberService extends BackendBaseService {
  url = 'phone_numbers';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  getPhoneNumbers(data: any) {
    this.httpClient.get(`${this.url}.json`, data);
  }

  /**
   * DELETE action for Phone Number resource with a confirm param, used to confirm phone number delete if involvements are present
   * @param  {number}       id Phone number id
   * @return {Promise<any>}    Response of destroy
   */
  deleteConfirm(id: number, alternatePhoneNumberId: number | undefined = undefined): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json?angular=2${alternatePhoneNumberId ? '&alternate_phone_number_id=' + alternatePhoneNumberId : ''}`);
  }

  /**
   * CREATE and UPDATE actions for Phone Number resource
   * @param  {PhoneNumber} phone_number Phone Number to be saved
   * @return {Promise<any>} Save response
   */
  save(phone_number: PhoneNumber): Promise<any> {
    if (phone_number.id) return this.httpClient.put(`${this.url}/${phone_number.id}.json`, { contact_id: phone_number.contact_id, phone_number: phone_number });
    else return this.httpClient.post(`${this.url}.json`, { contact_id: phone_number.contact_id, phone_number: phone_number });
  }

  /**
   * Update positions of phone numbers of a contact
   * @param  {number}           contactId Contact id
   * @param  {Array<number> =         []}          phone_number_ids Phone number ids in order
   * @return {Promise<any>}               Server response
   */
  updatePositions(contactId: number, phone_number_ids: Array<number> = []): Promise<any> {
    return this.httpClient.put(`${this.url}/update_positions.json`, { contact_id: contactId, phone_number_ids: phone_number_ids });
  }
}
